import { Container, createTheme, virtualColor, rem, DEFAULT_THEME, mergeMantineTheme } from '@mantine/core'

const CONTAINER_SIZES: Record<string, string> = {
    xxs: rem(500),
    xs: rem(600),
    sm: rem(900),
    md: rem(1100),
    lg: rem(1200),
    xl: rem(1600),
    xxl: rem(1800),
}

export const themeOverride = createTheme({
    fontFamily: 'Euclid Circular B',
    headings: { fontFamily: 'Euclid Circular B' },
    black: '#262424',
    white: '#fefefe',
    colors: {
        'brand': ['#fe0000', '#fe0000', '#fe0000', '#fe0000', '#fe0000', '#fe0000', '#fe0000', '#fe0000', '#fe0000', '#fe0000'],
        'text-primary': virtualColor({
            name: 'text-primary',
            dark: 'gray',
            light: 'dark',
        }),
        'bg-primary': virtualColor({
            name: 'bg-primary',
            dark: 'pink',
            light: 'cyan',
        }),
        yellow: [ //fed401
            "#fffce1",
            "#fff7cc",
            "#ffef9b",
            "#ffe564",
            "#ffde38",
            "#ffd91c",
            "#ffd609",
            "#e3bd00",
            "#c9a800",
            "#ae9100"
        ],
        orange: [ //fe7427
            "#fff0e2",
            "#ffe0cb",
            "#ffbe9a",
            "#ff9c64",
            "#fe7e36",
            "#fe6b19",
            "#ff6107",
            "#e35100",
            "#cb4500",
            "#b23900"
        ],
        violet: [ //9558cc
            "#f9edff",
            "#eadaf8",
            "#d0b2ea",
            "#b489dc",
            "#9d65d0",
            "#8f4ec9",
            "#8743c6",
            "#7534b0",
            "#682d9d",
            "#5a258c"
        ],
        blue: [ //00c6e8
            "#e0feff",
            "#ccf9ff",
            "#9cf0ff",
            "#68e8fe",
            "#43e0fd",
            "#2fdcfd",
            "#1ddbfe",
            "#00c2e3",
            "#00adcb",
            "#0096b2"
        ],
        green: [ //00bd7a
            "#e5fff7",
            "#d0ffee",
            "#a0fedd",
            "#6cfec9",
            "#47feba",
            "#34feaf",
            "#28feaa",
            "#19e393",
            "#00c982",
            "#00ae6e"
        ],
        pink: [ //ffafcb
            "#ffe8f3",
            "#ffcfe0",
            "#ff9cbe",
            "#fe659b",
            "#fd3a7c",
            "#fd1f69",
            "#fe105f",
            "#e3004f",
            "#cb0046",
            "#b2003b"
        ]
    },
    primaryColor: 'dark',
    components: {
        Container: Container.extend({
            vars: (_, { size, fluid }) => ({
                root: {
                    '--container-size': fluid
                        ? '100%'
                        : size !== undefined && size in CONTAINER_SIZES
                            ? CONTAINER_SIZES[size]
                            : rem(size),
                },
            }),
        }),
    }
})

export const DefaultTheme = mergeMantineTheme(DEFAULT_THEME, themeOverride)